import _values from "lodash/values";
import _isPlainObject from "lodash/isPlainObject";
export default {
  currentImage: state => state.currentImage,
  productInspiration: state => state.productInspiration,
  productCross: state => state.productCross,
  productComplementary: state => state.productComplementary,
  variants: state => state.variants,
  product: state => state.product,
  tc_vars: state => state.productNav.tc_vars.params,
  tracking: state => state.productNav.product.click_tracking,
  salesPromotion: state => state.productNav.sales_promotion,
  estimatedDelivery: state => state.productNav.product.estimated_delivery,
  categorySticker: state => _isPlainObject(state.productNav.product.segmentations.category_sticker) ? _values(state.productNav.product.segmentations.category_sticker) : state.productNav.product.segmentations.category_sticker,
  gamme: state => state.productNav.product.cross.gamme,
  olapic: state => state.productNav.product.olapic
};